import { Grid } from '~components';
import {
  List,
  Item,
  Description,
  Text,
} from '../CompanyTypeInformation/styled';

function CompanyTypeMeiLtda() {
  return (
    <Grid>
      <Text>
        Separe o contrato social da sua empresa com a última atualização na
        junta comercial em formato PDF.
      </Text>
      <Description>
        O contrato social é o documento que constitui uma sociedade simples ou
        empresária. Referida sociedade deve possuir uma finalidade lucrativa e
        seus sócios devem ser conhecidos e qualificados. O contrato social, é
        usado para regular os seguintes tipos societários regulados pelo Código
        Civil:
      </Description>
      <List>
        <Item>Sociedade simples (art. 997);</Item>
        <Item>Sociedade em nome coletivo (art. 1041);</Item>
        <Item>
          Sociedade em comandita simples (1045, parágrafo único, art.1046);
        </Item>
        <Item>Sociedade limitada (art. 1053, parágrafo único, art. 1054).</Item>
      </List>
    </Grid>
  );
}

export default CompanyTypeMeiLtda;
